/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoStore {
    'use strict';

    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import IMeevoStoreDocumentPolicy = Meevo.Plugins.MeevoStore.IMeevoStoreDocumentPolicy;
    import StoreActionTypeEnum = Meevo.Plugins.MeevoStore.StoreActionTypeEnum;

    export interface StoreAccountCartItem {
        actionType: StoreActionTypeEnum,
        editionSFId?: string,
        editionId?: string,
        messageOptionSFId?: string,
        messageOptionId?: string,
        supportPlanSFId?: string,
        supportPlanId?: string,
    }

    class AccountController {
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            '$q',
            "$translate",
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            'meevo.plugins.meevoStore.MeevoStoreService',
            "$sce",
            'meevo.ContextParams',
        ];
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;

        public isInDev: boolean = true;
        public today = moment();
        public documentTerms: IMeevoStoreDocumentPolicy;
        public documentPolicy: IMeevoStoreDocumentPolicy;
        public documentAdjustment: IMeevoStoreDocumentPolicy;

        public routeMeevoStore: string;
        public canDowngradeEdition: boolean;
        public canDowngradeSms: boolean;
        public accountInfo: IStoreAccountInfo;

        public currentEdition: IStoreEdition;
        public selectedEdition: IStoreEdition;

        public currentMessage: IMessageOption;
        public selectedMessage: IMessageOption;

        public currentSupportPlan: ISupportPlan;
        public selectedSupportPlan: ISupportPlan;

        public messageOptionsList: Array<any>;
        public supportPlansList: Array<any>;
        public millenniumExchangeUri: any;

        public hasXchangeSecurity: boolean;

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: ng.ui.IStateService,
            protected $q: angular.IQService,
            protected $translate: angular.translate.ITranslateService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected storeService: Meevo.Plugins.MeevoStore.IMeevoStoreService,
            protected $sce: ng.ISCEService,
            contextParams: Meevo.ContextParamsService
        ) {

            this.routeMeevoStore = this.appSettings.ROUTE_NAMES.meevoStore;

            let linkType = LinkType.MillenniumExchange;
            if (contextParams && contextParams.params && contextParams.params.linkType) {
                linkType = contextParams.params.linkType;
            }

            storeService.getXchangeOptions(Meevo.Components.Common.SecurityKeys.MEEVOSTORE_MEEVOEXCHANGESSO, linkType)
                .then(opt => {
                    this.hasXchangeSecurity = opt.hasXchangeSecurity;
                    this.millenniumExchangeUri = opt.millenniumExchangeUri;
                });


            this.storeService.getAccountInfo().then((data) => {
                this.accountInfo = data;

                if (this.accountInfo.pendingRequests && this.accountInfo.pendingRequests.length > 0) {
                    let textIsPending = this.$translate.instant('LABEL_MEEVOSTORE_IS_PENDING',
                        {
                            salesforceOrder: this.accountInfo.pendingRequests[0].salesForceReferenceNumber,
                            meevoItem: 'Meevo plan',
                            moduleName: this.accountInfo.pendingRequests[0].displayName
                        });
                    this.modalService.alert(textIsPending, Meevo.Components.Modal.ModalTranslationModes.Translate);
                }

                this.updateCurrentPlans(this.accountInfo);
            });

            this.storeService.getTerms(SystemDocumentsTypeEnum.MeevoStoreTermsAndConditions).then((data) => {
                this.documentTerms = data;
            });
            this.storeService.getTerms(SystemDocumentsTypeEnum.MeevoStorePrivacyPolicy).then((data) => {
                this.documentPolicy = data;
            });
            this.storeService.getTerms(SystemDocumentsTypeEnum.MeevoStoreAdjustment).then((data) => {
                this.documentAdjustment = data;
            });
        }

    public updateCurrentPlans(data): void {
            this.accountInfo = data;

            this.setLastTimeChanged();

            this.canDowngradeEdition = this.accountInfo.lastTimeMessagingPlanChangedCountDays > 30 && this.accountInfo.lastTimeMeevoPlanChangedCountDays > 30 && !this.accountInfo.editionPlanPending;

            this.accountInfo.meevoEditions.forEach((el) => {
               el.includes = el.includedText.split(',')
            });

            this.currentEdition = this.selectEditionById(this.accountInfo.currentEditionId);
            this.selectEdition(this.selectEditionById((this.accountInfo.editionPlanPending && this.accountInfo.editionPlanPending.entityId) || this.accountInfo.currentEditionId));

            this.currentMessage = this.selectMessageOptionById(this.accountInfo.currentMessageId);
            this.selectMessageOption(this.selectMessageOptionById((this.accountInfo.messagePlanPending && this.accountInfo.messagePlanPending.entityId) || this.accountInfo.currentMessageId || null));

            this.accountInfo.supportPlans.forEach((el) => {
                el.descriptions = el.description.split(',')
            });
            this.currentSupportPlan = this.selectSupportPlanById(this.accountInfo.currentSupportPlanId);
            this.selectSupportPlan(this.selectSupportPlanById((this.accountInfo.supportPlanPending && this.accountInfo.supportPlanPending.entityId) || this.accountInfo.currentSupportPlanId));
        }

    setLastTimeChanged() {
            if (this.accountInfo.lastTimeMeevoPlanChanged) {
                this.accountInfo.lastTimeMeevoPlanChangedCountDays = moment().startOf('day').diff(moment(this.accountInfo.lastTimeMeevoPlanChanged), 'days');
            } else {
                this.accountInfo.lastTimeMeevoPlanChangedCountDays = 999;
            }

            if (this.accountInfo.lastTimeMessagingPlanChanged) {
                this.accountInfo.lastTimeMessagingPlanChangedCountDays = moment().startOf('day').diff(moment(this.accountInfo.lastTimeMessagingPlanChanged), 'days');
            } else {
                this.accountInfo.lastTimeMessagingPlanChangedCountDays = 999;
            }

            if (this.accountInfo.lastTimeSupportPlanChanged) {
                this.accountInfo.lastTimeSupportPlanChangedCountDays = moment().startOf('day').diff(moment(this.accountInfo.lastTimeSupportPlanChanged), 'days');
            } else {
                this.accountInfo.lastTimeSupportPlanChangedCountDays = 999;
            }
        }

    public selectEdition(edition: IStoreEdition): void {
            if (!edition && !this.selectedEdition) {
                edition = this.currentEdition = this.accountInfo.meevoEditions[0];
            }

            if (edition.sequenceNumber < this.currentEdition.sequenceNumber && !this.canDowngradeEdition) {
                let alertText = this.$translate.instant('LABEL_MEEVO_TEXT_MESSAGE_PLAN_CANNOT_BE_DOWNGRADED_30_DAYS',
                    {
                        nextBillingDate: moment(this.accountInfo.lastTimeMeevoPlanChanged).add(30, 'days').format('L'),
                    });
                this.modalService.alert(alertText);
                return;
            }

            if (this.selectedEdition != edition) {
                this.selectedEdition = edition;
            } else {
                this.selectedEdition = this.selectEditionById(this.accountInfo.currentEditionId);
            }

            // Message Options
            this.filterMessageList();
            let minMessage = this.selectMessageOptionById(this.selectedEdition.smsPlanId);
            let currentMessage = _.find(this.messageOptionsList, (el: any) => el.smsPlanId == this.accountInfo.currentMessageId);
            if (minMessage && !currentMessage) {
                this.selectedMessage = minMessage;
            } else {
                this.selectedMessage = currentMessage;
            }

            // Support Plan
            this.filterSupportPlanList();
            let minSupportPlan = this.selectSupportPlanById(this.selectedEdition.supportPlanId);
            let currentSupportPlan = _.find(this.supportPlansList, (el: any) => el.supportPlanId == this.accountInfo.currentSupportPlanId);
            if (minSupportPlan && !currentSupportPlan) {
                this.selectedSupportPlan = minSupportPlan;
            } else {
                this.selectedSupportPlan = currentSupportPlan;
            }
        }

        public meevoXchangeURL(): any {

            setTimeout(() => {
                this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + 'MeevoStore/CommunityLink', 'GET', null, { 'LinkType': LinkType.MillenniumExchange }).then(data => {
                     this.millenniumExchangeUri = this.$sce.trustAsResourceUrl(data.data.link);
                });
            }, 0);
        }

    public selectEditionById(id): IStoreEdition {
            return _.find(this.accountInfo.meevoEditions, (el) => {
                return el.editionPlanId == id;
            });
        }

    public isEditionDisabled(item: IStoreEdition): boolean {
            return !!this.accountInfo.editionPlanPending || (this.accountInfo.pendingRequests && this.accountInfo.pendingRequests.length > 0);
        }

        /*
        * Message Options
        * */
    public isMessageOptionDisabled(item: IMessageOption): boolean {
            return !!this.accountInfo.messagePlanPending || (this.accountInfo.pendingRequests && this.accountInfo.pendingRequests.length > 0);
        }

    public selectMessageOption(item): void {
            if (!item) {
                item = this.currentMessage = this.accountInfo.messageOptions[0];
            }

            if (item.sequenceNumber < this.currentMessage.sequenceNumber && this.accountInfo.lastTimeMessagingPlanChangedCountDays <= 30 && !this.accountInfo.messagePlanPending) {
                let alertText = this.$translate.instant('LABEL_MEEVO_TEXT_MESSAGE_PLAN_CANNOT_BE_DOWNGRADED_30_DAYS',
                    {
                        nextBillingDate: moment(this.accountInfo.lastTimeMessagingPlanChanged).add(30, 'days').format('L'),
                    });
                this.modalService.alert(alertText);
                return;
            }

            if (this.selectedMessage != item) {
                this.selectedMessage = item;
            } else {
                this.selectedMessage = this.selectMessageOptionById(this.accountInfo.currentMessageId);
            }
        }

    public selectMessageOptionById(id): IMessageOption {
      return _.find(this.accountInfo.messageOptions, (el) => {
                return el.smsPlanId == id;
            });
        }

    public filterMessageList(): void {
            if (this.selectedEdition && this.selectedEdition.smsPlanId) {
                this.messageOptionsList = this.accountInfo.messageOptions.filter(el => {
                    if (this.accountInfo.messagePlanUpgrades) {
                        let upgrade: any = _.find(this.accountInfo.messagePlanUpgrades, (item: any) => {
                            return item.smsPlanId == el.smsPlanId && this.selectedEdition.editionPlanId == item.editionPlanId;
                        });
                        if (upgrade) {
                            el.price = upgrade.upgradePrice;
                        }
                    }
                    return el.price !== undefined && el.smsPlanId >= this.selectedEdition.smsPlanId;
                });
            } else {
                this.messageOptionsList = angular.copy(this.accountInfo.messageOptions);
            }
        }

    public getMessageOptionHeader(el: IMessageOption): string {
            if (this.currentMessage.smsPlanId == el.smsPlanId) {
                return 'LABEL_CURRENT';
            }
            if (this.selectedEdition.smsPlanId == el.smsPlanId) {
                return 'LABEL_INCLUDED';
            }
            if (this.currentMessage.sequenceNumber > el.sequenceNumber) {
                return 'LABEL_DOWNGRADE';
            }
            if (this.currentMessage.sequenceNumber < el.sequenceNumber) {
                return 'LABEL_UPGRADE';
            }
        }

        /*
        * Support Plans
        * */
    public isSupportPlansDisabled(item: ISupportPlan): boolean {
            return !!this.accountInfo.supportPlanPending || (this.accountInfo.pendingRequests && this.accountInfo.pendingRequests.length > 0);
        }

    public selectSupportPlan(item: ISupportPlan): void {
            if (!item) {
                item = this.currentSupportPlan = this.accountInfo.supportPlans[0];
            }

            if (item.sequenceNumber < this.currentSupportPlan.sequenceNumber && this.accountInfo.lastTimeSupportPlanChangedCountDays <= 30) {
                let alertText = this.$translate.instant('LABEL_MEEVO_TEXT_MESSAGE_PLAN_CANNOT_BE_DOWNGRADED_30_DAYS',
                    {
                        nextBillingDate: moment(this.accountInfo.lastTimeSupportPlanChangedCountDays).add(30, 'days').format('L'),
                    });
                this.modalService.alert(alertText);
                return;
            }

            if (this.selectedSupportPlan != item) {
                this.selectedSupportPlan = item;
            } else {
                this.selectedSupportPlan = this.selectSupportPlanById(this.accountInfo.currentSupportPlanId);
            }
        }

    public selectSupportPlanById(id): ISupportPlan {
      return _.find(this.accountInfo.supportPlans, (el) => {
                return el.supportPlanId == id;
            });
        }

    public filterSupportPlanList(): void {
            if (this.selectedEdition && this.selectedEdition.supportPlanId) {
                this.supportPlansList = this.accountInfo.supportPlans.filter((el: ISupportPlan) => {
                    if (this.accountInfo.supportPlanUpgrades) {
                        let upgrade: any = _.find(this.accountInfo.supportPlanUpgrades, (item: any) => {
                            return item.supportPlanId == el.supportPlanId && this.selectedEdition.editionPlanId == item.editionPlanId;
                        });
                        if (upgrade) {
                            el.price = upgrade.upgradePrice;
                        }
                    }
                    return el.supportPlanId >= this.selectedEdition.supportPlanId;
                });
            } else {
                this.supportPlansList = angular.copy(this.accountInfo.messageOptions);
            }
        }

    public getSupportPlanHeader(el: ISupportPlan): string {
            if (this.currentSupportPlan.supportPlanId == el.supportPlanId) {
                return 'LABEL_CURRENT';
            }
            if (this.selectedEdition.supportPlanId == el.supportPlanId) {
                return 'LABEL_INCLUDED';
            }
            if (this.currentSupportPlan.sequenceNumber > el.sequenceNumber) {
                return 'LABEL_DOWNGRADE';
            }
            if (this.currentSupportPlan.sequenceNumber < el.sequenceNumber) {
                return 'LABEL_UPGRADE';
            }
        }

    public isProcessBtnDisabled(): boolean {
            return this.accountInfo && (!!this.accountInfo.editionPlanPending || !!this.accountInfo.messagePlanPending) || this.isProcessDisable();
        }

    public isProcessDisable() {
            return this.selectedEdition
                && this.selectedEdition.editionPlanId == this.currentEdition.editionPlanId
                && this.selectedMessage
                && this.selectedMessage.smsPlanId == this.currentMessage.smsPlanId
                && this.selectedSupportPlan
                && this.selectedSupportPlan.supportPlanId == this.currentSupportPlan.supportPlanId;
        }

    public processBtn(): ng.IPromise<any> {
            let cartItem: StoreAccountCartItem = {
                actionType: StoreActionTypeEnum.Add,
            };

            let confirmItem = `<ul class="text-capitalize">`;
            if (this.selectedEdition.editionPlanId !== this.currentEdition.editionPlanId) {
                confirmItem += `<li><strong>${this.selectedEdition.displayName} ${this.$translate.instant('LABEL_MEEVO_EDITION_UPGRADE_OPTION')}</strong></li>`;
                cartItem.editionId = this.selectedEdition.editionPlanId;
                cartItem.editionSFId = this.selectedEdition.salesForceIdentifier;
            }
            if (this.selectedMessage.smsPlanId !== this.currentMessage.smsPlanId) {
                confirmItem += `<li><strong>${this.selectedMessage.displayName}</strong></li>`;
                cartItem.messageOptionId = this.selectedMessage.smsPlanId;
                cartItem.messageOptionSFId = this.selectedMessage.salesForceIdentifier;
            }
            if (this.selectedSupportPlan.supportPlanId !== this.currentSupportPlan.supportPlanId) {
                confirmItem += `<li><strong>${this.selectedSupportPlan.displayName} ${this.$translate.instant('LABEL_SUPPORT_PLAN_OPTION')}</strong></li>`;
                cartItem.supportPlanId = this.selectedSupportPlan.supportPlanId;
                cartItem.supportPlanSFId = this.selectedSupportPlan.salesForceIdentifier;
            }
            confirmItem += `</ul>`;

            let headerContentKey = 'HEADER_CONFIRM',
                confirmText = 'TEXT_MEEVOSTORE_CONFIRM_MAKE_CHANGES_ACCOUNT';

            // Initialize modal
            return this.storeService.openConfirmModal(headerContentKey, confirmText, confirmItem).then((res) => {
        if (res.status === true) {

                    this.busyService.start();

                    // Add item to cart
                    this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + this.appSettings.ROUTE_NAMES.meevoStore + '/MeevoEdition', 'POST', cartItem).then(response => {
                        this.busyService.stop();

                        if (response.status == 409) {
                            this.modalService.error(response.data.responseStatus.message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                            return;
                        }

                        // Update data on the page
                        this.storeService.getAccountInfo().then((data: any) => {
                            this.updateCurrentPlans(data);
                        });

                        this.storeService.openPurchaseModal(response.data.orderNumber);
                    });
                }
            });
        }

        public openTerms (documentsText: string, modalTitle: string = 'LABEL_TERMS_OF_SERVICE') {
            this.storeService.openTermsModal(documentsText, modalTitle);
        }
    }
    angular.module('meevo.plugins.meevoStore')
        .controller('meevo.plugins.meevoStore.AccountController', AccountController);
}